import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DatasetSchema } from '../../../services/schemas.service';

import { SchemaColumn } from '../../../services/schemas.service';

export type SchemaStructureDialogData = {
  schemaName: string;
  schema: DatasetSchema;
};

@Component({
  selector: 'app-schema-structure-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './schema-structure-dialog.component.html',
  styleUrl: './schema-structure-dialog.component.scss'
})
export class SchemaStructureDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: SchemaStructureDialogData) {}

  get schemaColumns(): SchemaColumn[] {
    return this.data.schema?.columns ?? this.data.schema?.schema ?? [];
  }

  constraintChips(col: SchemaColumn): string[] {
    const chips: string[] = [];
    if (col.unique)                 chips.push('único');
    if (col.max_length   != null)   chips.push(`máx ${col.max_length} chars`);
    if (col.min_value    != null)   chips.push(`min ${col.min_value}`);
    if (col.max_value    != null)   chips.push(`max ${col.max_value}`);
    if (col.precision    != null)   chips.push(`precisión ${col.precision}`);
    if (col.scale        != null)   chips.push(`${col.scale} decimales`);
    if (col.date_format)            chips.push(col.date_format);
    if (col.regex)                  chips.push(`regex`);
    if (col.enum_values?.length)    chips.push(`${col.enum_values.length} valores`);
    return chips;
  }
}
